// extracted by mini-css-extract-plugin
export default {"mainContent":"Deposit_mainContent__3HEdu","formControl":"Deposit_formControl__3kxA5","copy":"Deposit_copy__-xtaN"};